import React from 'react';

import {RunQueryContext} from '../../state/runs/context';
import {LoaderProxy} from './../../containers/AppLoader';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {MultiRunWorkspaceWorkspace} from './../MultiRunWorkspace';
import NoMatch from './../NoMatch';
import {MultiRunWorkspaceProps} from './types';
import {useMultiRunWorkspaceQueryProps} from './useMultiRunWorkspaceQueryProps';

export const MultiRunWorkspaceWithContext = (props: MultiRunWorkspaceProps) => {
  const {entityName, projectName, runsQueryContextValue} = props;
  const multiRunWorkspaceProps = useMultiRunWorkspaceQueryProps(props);

  const value = React.useMemo(() => {
    return {
      entityName,
      projectName,
      mergeFilters: props.mergeFilters,
      runSetName: props.runSetName,
      ...runsQueryContextValue,
    };
  }, [
    entityName,
    projectName,
    runsQueryContextValue,
    props.mergeFilters,
    props.runSetName,
  ]);

  if (multiRunWorkspaceProps.loading) {
    return <LoaderProxy name="multi-run-workspace-loader" />;
  }
  if (multiRunWorkspaceProps.error) {
    return <NoMatch />;
  }

  return (
    <RunQueryContext.Provider value={value}>
      <MultiRunWorkspaceWorkspace
        {...props}
        {...multiRunWorkspaceProps.readyProps}
      />
    </RunQueryContext.Provider>
  );
};
